import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { FC } from "react";

export type CustomCodeProps = SliceComponentProps<Content.CustomCodeSlice>;

const CustomCode: FC<CustomCodeProps> = ({ slice }) => {
  return (
    <div
      data-analytics-component="custom-code"
      style={{ marginTop: "100px" }}
      dangerouslySetInnerHTML={{
        __html: `${(slice.primary.markup[0] as any).text}`,
      }}
    />
  );
};

export default CustomCode;
